<template>
  <div>
    <van-nav-bar fixed placeholder title="商家模式" />

    <div class="main">
      <van-row gutter="4">
        <van-col span="24">
          <van-button @click="cmdTable">行動開桌</van-button>
        </van-col>
        <van-col span="24">
          <van-button @click="cmdBell">服務鈴監控</van-button>
        </van-col>
        <van-col span="24">
          <van-button @click="cmdMenu">菜單編輯</van-button>
        </van-col>
        <van-col span="24">
          <van-button @click="cmdConfig">系統設置</van-button>
        </van-col>
      </van-row>
    </div>

    <van-tabbar fixed placeholder>
      <van-button type="primary" size="large">Copyright©葆光POS餐飲系統</van-button>
    </van-tabbar>

    <audio id="mySound" :src="mp3.m1"></audio>
    <audio id="closeSound" :src="mp3.m2"></audio>
  </div>
</template>
<style scoped></style>
<script>
export default {
  data() {
    return {
      mp3: {
        m1: require("@/assets/bell.mp3"),
        m2: require("@/assets/close.mp3"),
      },
    };
  },
  mounted() {
    console.log("Index.monted");
  },
  methods: {
    cmdBell() {
      this.$router.push("/bkbell");
    },
    cmdTable() {
      this.$router.push("/bktable");
    },
    cmdMenu() {
      this.$router.push("/bkmenu");
    },
    cmdConfig() {
      this.$router.push("/config");
    },
    playMp3() {
      // return new Promise((resolve) => {
      document.getElementById("mySound").currentTime = 0;
      document.getElementById("mySound").play();
      //     resolve();
      // });
    },
    cmdTest() {
      this.gMsgbox("hello", "title");
    },
  },
};
</script>
